import React from 'react';
import { HiSparkles } from 'react-icons/hi';
import { 
  FaUniversity, 
  FaProjectDiagram, 
  FaDatabase, 
  FaWallet 
} from 'react-icons/fa';
import CleanButton from '../CleanButton/CleanButton'; // Your button component
import './SubscriptionCard.scss';

const SubscriptionCard = ({ 
  planName, 
  credits, 
  flowNodeRuns, 
  storage, 
  maxCreditsToHold, 
  price, 
  priceWithVat, 
  isPopular = false 
}) => {
  return (
    <div className={`subscription-card ${isPopular ? 'popular' : ''}`}>
      <div className="card h-100">
        <div className="card-body d-flex flex-column">
          {/* Header */}
          <div className="d-flex align-items-center mb-3">
            <HiSparkles className="plan-icon me-2" />
            <h5 className="card-title mb-0">{planName}</h5>
          </div>

          {/* Features */}
          <div className="features flex-grow-1">
            {/* Credits */}
            <div className="feature-item d-flex align-items-start mb-3">
              <div className="feature-icon me-3">
                <FaUniversity className="icon-credits" />
              </div>
              <div className="feature-content">
                <div className="feature-label">Credits / Month</div>
                <div className="feature-value">{credits.toLocaleString()}</div>
              </div>
            </div>

            {/* Flow Node Runs */}
            <div className="feature-item d-flex align-items-start mb-3">
              <div className="feature-icon me-3">
                <FaProjectDiagram className="icon-flow" />
              </div>
              <div className="feature-content">
                <div className="feature-label">Flow Node Runs / Day</div>
                <div className="feature-value">{flowNodeRuns.toLocaleString()}</div>
              </div>
            </div>

            {/* Storage */}
            <div className="feature-item d-flex align-items-start mb-3">
              <div className="feature-icon me-3">
                <FaDatabase className="icon-storage" />
              </div>
              <div className="feature-content">
                <div className="feature-label">Storage</div>
                <div className="feature-value">{storage}</div>
              </div>
            </div>

            {/* Max Credits to Hold */}
            <div className="feature-item d-flex align-items-start mb-4">
              <div className="feature-icon me-3">
                <FaWallet className="icon-wallet" />
              </div>
              <div className="feature-content">
                <div className="feature-label">Max Credits to Hold</div>
                <div className="feature-value">{maxCreditsToHold.toLocaleString()}</div>
              </div>
            </div>
          </div>

          {/* Price Button using your CleanButton component */}
          <div className="mt-auto">
            <div className="price-button-container">
              <CleanButton
                variant="primary"
                size="lg"
                className="w-100 price-button-custom"
                disabled={true}
              >
                <span className="price-text">{price} €</span>
              </CleanButton>
            </div>
            <div className="price-note text-center mt-2">
              {priceWithVat} € with VAT included
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCard;